import { useMinimizedModalsContext } from '../../../../../hooks'
import { getReplaceConfirmation, MINIMIZED_MODAL_KEY } from '../../../../Modal'

import { replaceMinimizedListingForm } from './useRentalPortalListingFormOpener.utils'

export function useRentalPortalListingFormOpener() {
  const { getEntry, showConfirmation } = useMinimizedModalsContext()

  function openListingForm({ sourceId, onOpen }) {
    const entry = getEntry(MINIMIZED_MODAL_KEY.RENTAL_PORTAL_LISTING_FORM)

    if (!entry || entry.sourceId === sourceId) {
      onOpen()

      return
    }

    showConfirmation(
      getReplaceConfirmation({
        displacedEntry: entry,
        onSubmit: () =>
          replaceMinimizedListingForm({ displacedEntry: entry, onOpen }),
      })
    )
  }

  return { openListingForm }
}
